import { useQuery } from "react-query";
import { getOfficeBrands } from "../../../../actions/CarrierAgreementMgmt/OfficeSettings";

export const useGetActiveOfficeBrand = () => {
  return useQuery("OfficeBrand", getOfficeBrands, {
    refetchOnWindowFocus: false,
  });
};
